// extracted by css-extract-rspack-plugin
export default {"cls1":"PodcastLibraryCarouselAd-cls1_6hH","cls2":"PodcastLibraryCarouselAd-cls2_yNS PodcastLibraryCarouselAd-cls1_6hH"};